export default __webpack_public_path__ + "static/media/logop9map.7b4ffed6.png";